<template>
    <span class="attendee-online" title="Online now"></span>
</template>
<script>
// Minimal widget to display that an attendee is online.
// No props because we only show this once we've established they're eligible.
export default {
  name: "AttendeeOnline",
  props: {
  },
}
</script>
<style>
.attendee-online {
    background-color: seagreen;
    border-radius: 50%;
    display: inline-block;
    height: 10px;
    margin-right: 5px;
    width: 10px;
}
</style>